import {features} from '@/model-as-code/features'

const FIBR_PAGE_URLS = new Set([
	'/campaign/credelio-quattro-dog',
	'/campaign/stop-sucking-with-seresto',
])

const normalizePath = (pageUrl: string | undefined): string => {
	if (!pageUrl) return ''
	const trimmed = pageUrl.trim()
	if (!trimmed) return ''
	if (trimmed === '/') return '/'
	return trimmed.endsWith('/') ? trimmed.slice(0, -1) : trimmed
}

const hasFibrFeatureFlag = (
	featuresList: {codename: string}[] | undefined
): boolean => {
	const fibrFeature = features.fibrYpayPilot
	if (!fibrFeature) return false

	const featureCodename = fibrFeature.codename
	if (!featureCodename) return false

	return (
		featuresList?.some((feature) => feature.codename === featureCodename) ??
		false
	)
}

export const isFibrPilotPage = ({
	tower,
	locale,
	pageUrl,
	featuresList,
}: {
	tower: string
	locale: string | undefined
	pageUrl: string | undefined
	featuresList: {codename: string}[] | undefined
}): boolean => {
	if (tower !== 'pet') return false
	if (locale !== 'us') return false
	if (!hasFibrFeatureFlag(featuresList)) return false

	return FIBR_PAGE_URLS.has(normalizePath(pageUrl))
}

export {FIBR_PAGE_URLS}
